module.exports = __webpack_public_path__ + "img/plus.9e2db572.svg";